import { useQuery } from "@tanstack/react-query";
import type { FreshnessMeta } from "@/lib/api";
import { getProductions } from "./api";
import { DEFAULT_STATUSES } from "./scope";
import { RunsTab } from "./runs/RunsTab";
import { DefinitionsTab } from "./definitions/DefinitionsTab";
import { RecordsTab } from "./records/RecordsTab";
import { ApproveTab } from "./approve/ApproveTab";
import { CostIndexTab } from "./cost_index/CostIndexTab";
import { SoldCostsTab } from "./sold_costs/SoldCostsTab";

export function usePcogsMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({ queryKey: ["pcogs", "productions", "all", DEFAULT_STATUSES.join(",")], queryFn: () => getProductions("all", DEFAULT_STATUSES), enabled });
  return enabled ? head.data?.meta : undefined;
}
export function PcogsModule({ activeTabKey, areaName }: { decision: "edit" | "view" | "none"; activeTabKey: string | null; areaName: string; ownerName?: string | null }) {
  switch (activeTabKey) {
    case "runs": return <RunsTab areaName={areaName} />;
    case "definitions": return <DefinitionsTab areaName={areaName} />;
    case "records": return <RecordsTab areaName={areaName} />;
    case "approve": return <ApproveTab areaName={areaName} />;
    case "sold_costs": return <SoldCostsTab areaName={areaName} />;
    case "cost_index":
    default: return <CostIndexTab areaName={areaName} />;
  }
}
